export default __webpack_public_path__ + "static/winnysklad-bcdb24d266f82134fbbd7d9f9dba47d4.svg";